import { combineReducers, persistReducer, sessionStorage } from "@grandvisionhq/state";
import "../bundles/state/bundles/selectors.js";
import { reducer as reducer$2 } from "../bundles/state/bundles/reducer.js";
import "../configurations/state/configurations/selectors.js";
import { reducer as reducer$4 } from "../configurations/state/configurations/reducer.js";
import "../configurator/state/configurator/selectors.js";
import { reducer } from "../configurator/state/configurator/reducer.js";
import { reducer as reducer$3 } from "../prescription/state/prescription/reducer.js";
import "../products/state/products/selectors.js";
import { reducer as reducer$1 } from "../products/state/products/reducer.js";
const getConfig = (key) => ({
  storage: sessionStorage,
  key
});
const prescriptionGlassesReducer = combineReducers({
  bundles: reducer$2,
  configurations: persistReducer(getConfig("grandvision_pg_configurations"), reducer$4),
  prescription: persistReducer(getConfig("grandvision_pg_prescription"), reducer$3),
  products: reducer$1,
  configurator: reducer
});
export {
  prescriptionGlassesReducer as default,
  getConfig
};
//# sourceMappingURL=reducer.js.map
